export const LEARNING_CENTER_CATEGORIES = {
  guidebooks: { title: 'Challenge Guidebooks', path: 'guidebooks', key: 'guidebooks', detailType: 'guidebook' },
  recipe_cards: {
    title: 'Recipe Cards for Semi-Prepared Meals',
    path: 'recipe_cards',
    key: 'recipeCards',
    detailType: 'recipe_card',
  },
  articles: { title: 'Articles', path: 'articles', key: 'articles', detailType: 'article' },
  recipes: { title: 'Recipes', path: 'recipes', key: 'recipes', detailType: 'recipe' },
  videos: { title: 'Videos', path: 'videos', key: 'videos', detailType: 'video' },
};

export const getCategoryMetaByPath = (path) => {
  const meta = LEARNING_CENTER_CATEGORIES[path];
  if (meta) return meta;
  return {
    title: path && path[0] ? path.charAt(0).toUpperCase() + path.slice(1) : '',
    path,
  };
};

export const getCategoryMetaByKey = (key) => {
  const meta = Object.values(LEARNING_CENTER_CATEGORIES).find((m) => m.key === key);
  if (meta) return meta;
  return {
    title: key && key[0] ? key.charAt(0).toUpperCase() + key.slice(1) : '',
    path: key ? key.toLowerCase() : '',
    key,
  };
};

export const LEARN_BASE = '/learn';

export const getCategoryBaseUrlByPath = (path) => {
  const meta = getCategoryMetaByPath(path);
  return `${LEARN_BASE}/${meta.path}`;
};

export const getCategoryBaseUrlByKey = (key) => {
  const meta = getCategoryMetaByKey(key);
  return `${LEARN_BASE}/${meta.path}`;
};

export const buildCategoryItemUrlByKey = (key, id) => {
  return `${getCategoryBaseUrlByKey(key)}/${id}`;
};

export default LEARNING_CENTER_CATEGORIES;
